/**
 * Whether the payslip list includes the identifier columns (Contract ID + Payslip
 * ID). Hard-coded to `false` for now — the columns are hidden, not removed: they
 * stay defined in `usePayslipColumns` and gated by this flag. Will be driven by the
 * Super-Admin RBAC flag once the backend lands (see the D6 TODO in PayslipsTable).
 * Kept here, outside the component, so the toggle is easy to find and flip.
 */
export const PAYSLIP_SHOW_IDS = false;
